import Vue from 'vue'
import * as userApi from '../../api/user'
import { PERMISSION } from '../../constants/permissions'

async function getMe({ commit }) {
  const user = await userApi.getMe()
  commit('setUser', user)
}

async function updateUser({ dispatch }, userUpdate) {
  try {
    await userApi.updateUser(userUpdate)
    await dispatch('getMe')
    dispatch('notify', { newNotification: { type: 'success', message: 'Sikeres adatmódosítás.' } })
  } catch (error) {
    dispatch('notify', { newNotification: { type: 'warning', message: 'Hiba a módosítások mentésekor.' } })
    throw error
  }
}

async function login({ dispatch }, loginData) {
  await userApi.login(loginData)
  await dispatch('getMe')
  //dispatch('notify', { newNotification: { type: 'success', message: 'Sikeres bejelentkezés.' } })
}

// eslint-disable-next-line no-unused-vars
async function logout({ commit, dispatch }) {
  try {
    await userApi.logout()
  } catch (err) {
    console.log('Logging out.')
  }

  commit('removeUser')
  //dispatch('notify', { newNotification: { type: 'info', message: 'Sikeres kijelentkezés.' } })
}

async function register({ dispatch }, registrationData) {
  try {
    await userApi.register(registrationData)
    Vue.$gtag.event('user_registration', {
      event_category: 'user_interaction'
    })
    //dispatch('notify', { newNotification: { type: 'success', message: 'Sikeres regisztráció!' } })
  } catch (err) {
    if (err?.response?.status === 409) {
      dispatch('notify', { newNotification: { type: 'danger', message: 'Ezzel az email címmel már regisztráltak!' } })
      throw err
    }
    throw err
  }
}

async function initiatePasswordReset({ dispatch }, email) {
  await userApi.initiatePasswordReset(email)
  dispatch('notify', { newNotification: { type: 'success', message: 'Jelszó emlékeztetés kezdeményezése sikeres!' } })
}

async function validateResetToken(_, passwordResetToken) {
  const { id } = await userApi.validateResetToken(passwordResetToken)
  return id
}

async function resetPassword({ dispatch }, passwordResetData) {
  await userApi.resetPassword(passwordResetData)
  dispatch('notify', { newNotification: { type: 'success', message: 'Jelszó visszaállítás sikeres!' } })
}

async function modifyPassword({ dispatch }, modifyPasswordData) {
  await userApi.modifyPassword(modifyPasswordData)
  dispatch('notify', { newNotification: { type: 'success', message: 'Jelszó módosítás sikeres!' } })
}

async function validateConfirmationData(_, confirmationData) {
  const { id } = await userApi.validateConfirmationData(confirmationData)
  return id
}

async function confirmRegistration({ dispatch }, confirmationData) {
  await userApi.confirmRegistration(confirmationData)
  dispatch('notify', { newNotification: { type: 'success', message: 'Regisztráció megerősítve!' } })
}

function userRateLimited({ commit }, status) {
  commit('setUserRateLimited', status)
}

function tooManyResult({ commit }, status) {
  commit('setTooManyResult', status)
}

function setUser(state, newUser) {
  state.user = newUser
}

function setUserRateLimited(state, rateLimitStatus) {
  state.userRateLimited = rateLimitStatus
}

function setTooManyResult(state, tooManyResultStatus) {
  state.tooManyResult = tooManyResultStatus
}

function removeUser(state) {
  state.user = undefined
}

function userHaveReadPermission(state) {
  const userPermissions = state.user.role.permissions

  const listPermissions = [
    PERMISSION.VALI_USER_LIST,
    PERMISSION.VALI_COMPETITION_LIST,
    PERMISSION.VALI_COMPLEX_CONDITION_LIST,
    PERMISSION.VALI_CURRENT_PROGRAM_LIST,
    PERMISSION.VALI_PRIVATE_SERVICES_LIST,
    PERMISSION.VALI_ROLE_LIST,
    PERMISSION.VALI_NEWS_LIST
  ]

  const permissionSet = new Set(listPermissions)

  const isPermissionFound = userPermissions.find(permission => permissionSet.has(permission))

  if (isPermissionFound) {
    return true
  }
  return false
}

function userHaveSpecificPermission(state, specificPermission) {
  const userPermissions = state.user.role.permissions

  const isPermissionFound = userPermissions.find(permission => permission.toString() === specificPermission)

  if (isPermissionFound) {
    return true
  }
  return false
}

const userStore = {
  state: { user: null, userRateLimited: false, tooManyResult: false },
  actions: {
    getMe,
    updateUser,
    login,
    logout,
    register,
    initiatePasswordReset,
    validateResetToken,
    resetPassword,
    validateConfirmationData,
    confirmRegistration,
    modifyPassword,
    userRateLimited,
    tooManyResult
  },
  mutations: {
    setUser,
    removeUser,
    setUserRateLimited,
    setTooManyResult
  },
  getters: {
    isAuthenticated: state => {
      return !!state.user
    },
    getUser: state => {
      return state.user
    },
    getUserRateLimitedStatus: state => {
      return state.userRateLimited
    },
    getTooManyResultStatus: state => {
      return state.tooManyResult
    },
    userHaveReadPermission: state => {
      return userHaveReadPermission(state)
    },
    userHaveSpecificPermission: state => permission => {
      return userHaveSpecificPermission(state, permission)
    }
  }
}

export default userStore
